export default __webpack_public_path__ + "static/media/karmayogi-volunteer-pac2.6cebca5b.jpeg";